import axios from "axios";
import store from "../store/index.js";
import { MessageBox, Message } from "element-ui";
// import {
//   getToken
// } from './auth.js'
// //创建axios实例
const service = axios.create({
  baseURL: "http://zplan.zimax.com.cn/",
  timeout: 5000,
});
// console.log(process.env.API_HOST)
// //请求拦截器
service.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    // if (store.getters.token) {
    //   // 让每个请求携带token-- ['X-Litemall-Admin-Token']为自定义key 请根据实际情况自行修改
    //   config.headers['X-Zplan-Admin-Token'] = getToken()
    // }
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

//请求拦截的响应

service.interceptors.response.use(
  (response) => {
    // console.log(response.data)
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    };
    
    const res = response.data;

    if (res.errno === 501) {
      MessageBox.alert("系统未登录，请重新登录", "错误", {
        confirmButtonText: "确定",
        type: "error",
      }).then(() => {
        store.dispatch("FedLogOut").then(() => {
          location.reload();
        });
      });
      return Promise.reject("error");
    } else if (res.errno === 502) {
      MessageBox.alert("系统内部错误，请联系管理员维护", "错误", {
        confirmButtonText: "确定",
        type: "error",
      });
      return Promise.reject("error");
    } else if (res.errno === 503) {
      MessageBox.alert("请求业务目前未支持", "警告", {
        confirmButtonText: "确定",
        type: "error",
      });
      return Promise.reject("error");
    } else if (res.errno === 504) {
      MessageBox.alert("更新数据已经失效，请刷新页面重新操作", "警告", {
        confirmButtonText: "确定",
        type: "error",
      });
      return Promise.reject("error");
    } else if (res.errno === 505) {
      MessageBox.alert("更新失败，请再尝试一次", "警告", {
        confirmButtonText: "确定",
        type: "error",
      });
      return Promise.reject("error");
    } else if (res.errno === 405) {
      MessageBox.alert("没有操作权限，请联系管理员授权", "错误", {
        confirmButtonText: "确定",
        type: "error",
      });
      return Promise.reject("error");
    } else if (res.errno !== 0) {
      // 非5xx的错误属于业务错误，留给具体页面处理
      return Promise.reject(response);
    } else {
      return response;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    if (error.response.status === 405) {
      MessageBox.alert("没有操作权限，请联系管理员授权", "错误", {
        confirmButtonText: "确定",
        type: "error",
      });
      return Promise.reject("error");
    } else if (error.response.status === 404) {
      MessageBox.alert("登录超时，请重新登录", "错误", {
        confirmButtonText: "确定",
        type: "error",
      });
      return Promise.reject("error");
    } else {
      Message({
        message: "登录连接超时（后台不能连接，请联系系统管理员）",
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject(error);
    }
  }
);

// service.interceptors.response.use(
//   reponse => {
//     console.log(reponse)
//     // if (response.status === 200){
//     //   return Promise.resolve(reponse);
//     // }else{
//     //   return Promise.reject(reponse);
//     // }
//     const code = reponse.data.errno;
//     if (code === 404) {
//       MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录',
//         '系统提示', {
//           confirmButtonText: '重新登录',
//           cancelButtonText: '取消',
//           type: 'warning'
//         }).then(() => {
//         store.dispatch('LOGIN_OUT').then(() => {
//           location.reload() //重新实例化vue-touter对象，不免bug
//         })
//       })
//     } else if (code !== 0) {
//       Notification.error({
//         title: res.data.errmsg
//       })
//       return Promise.reject('error')
//     } else {
//       return res.data
//     }
//   },
//   error => {
//     console.log('err' + error)
//     Message({
//       message: error.message,
//       type: 'error',
//       duration: 5 * 1000
//     })
//     return Promise.reject(error)
//   }
// )
export default service;
